export type UserScopedCacheStorage = Pick<CacheStorage, 'delete' | 'keys'>;

const appCacheFamilyPrefix = (hostname: string, family: 'images' | 'run-time'): string => {
	return `${hostname}-infra-struktur-app-${family}-`;
};

export const isUserScopedCacheName = (cacheName: string, hostname: string): boolean => {
	if (hostname.length === 0) {
		return false;
	}

	return (
		cacheName.startsWith(appCacheFamilyPrefix(hostname, 'images')) ||
		cacheName.startsWith(appCacheFamilyPrefix(hostname, 'run-time'))
	);
};

export const clearUserScopedServiceWorkerCaches = async (
	cacheStorage: UserScopedCacheStorage | null = typeof caches === 'undefined' ? null : caches,
	hostname: string = typeof window === 'undefined' ? '' : window.location.hostname
): Promise<void> => {
	if (cacheStorage === null || hostname.length === 0) {
		return;
	}

	const cacheNames = await cacheStorage.keys();
	const userScopedCacheNames = cacheNames.filter((cacheName) => isUserScopedCacheName(cacheName, hostname));

	await Promise.all(userScopedCacheNames.map((cacheName) => cacheStorage.delete(cacheName)));
};
